export enum CountStatusEnum {
  INIT_STATUS = "Clique em contar para efetuar a contagem",
  LOADING_STATUS = "Contando... Isso pode demorar um pouco",
  ERROR_STATUS = "Falha ao contar",
  COMPLETED = "Contagem completa",
}
